import { render, staticRenderFns } from "./SKStepper.vue?vue&type=template&id=22c0f1a7&ref=template&"
import script from "./SKStepper.vue?vue&type=script&lang=js&"
export * from "./SKStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports